import React from 'react';
import { useSelector } from 'react-redux';
import OrgNotifications from './OrgNotifications';
import MemberNotifications from './MemberNotifications';
import IndividualNotifications from './IndividualNotifications';

export default function Notifications() {
  const { profileData } = useSelector((state) => state.profile);
  return (
    <div className='sm:max-w-9xl w-full px-4 sm:mx-auto sm:px-6'>
      <div className='grid-col-1 grid gap-6 sm:grid-cols-3'>
        {profileData?.account_type == 'ORGANIZATION' ? (
          <OrgNotifications accountType={profileData?.account_type} />
        ) : profileData?.account_type == 'ORGANIZATION_MEMBER' ? (
          <MemberNotifications accountType={profileData?.account_type} />
        ) : (
          <IndividualNotifications accountType={profileData?.account_type} />
        )}
      </div>
    </div>
  );
}
